import { Injectable } from '@angular/core';
import { DvDynamicFormElement } from '@devinco/ui/legacy';
import {
  DvCheckboxElement,
  DvSlideToggleElement,
  DvTextareaElement,
} from '@devinco/ui/legacy';

@Injectable()
export class TimedMarkerMapMenuFormService {
  readonly mainSettingsElements = [
    new DvCheckboxElement({
      colspan: 12,
      key: 'autoRefresh',
      checkboxLabel: 'TimedMarkerMenuForm.AutoRefresh',
      rowspan: 2,
    }),
    new DvCheckboxElement({
      colspan: 12,
      key: 'autoZoomFit',
      checkboxLabel: 'TimedMarkerMenuForm.AutoZoomFit',
      rowspan: 2,
    }),
  ];

  readonly clusteringFormElements = [
    new DvCheckboxElement({
      colspan: 12,
      key: 'groupMarkers',
      checkboxLabel: 'TimedMarkerMenuForm.GroupMarkers',
      rowspan: 2,
    }),
  ];

  readonly searchElement: DvDynamicFormElement[] = [
    new DvTextareaElement({
      key: 'searchAddress',
      placeholder: 'Grid.searchOoo',
      colspan: 12,
    }),
  ];

  readonly slideToggleElement = (label: string): DvDynamicFormElement[] => [
    new DvSlideToggleElement({
      key: 'slideToggle',
      colspan: 12,
      slideToggleLabel: label,
    }),
  ];
}
